import { SlidersHorizontal } from "@phosphor-icons/react";
import { Button } from "@replicate/ui";
import { P, match } from "ts-pattern";
import type { Prediction } from "../../types";

export function TweakPrediction({
  prediction,
}: {
  prediction: Prediction;
}) {
  // We assume that every deployable other than deployments has a playground on
  // it root page.
  const tweakUrl = match(prediction._extras.ran_on)
    .with(
      {
        kind: "deployment",
      },
      (deployable) => `${deployable.url}/playground?prediction=${prediction.id}`
    )
    .with(
      {
        kind: P.union("model", "version"),
      },
      (deployable) =>
        `${prediction._extras.ran_on.url}?prediction=${prediction.id}`
    )
    .with(
      {
        kind: "hidden",
      },
      () => null
    )
    .exhaustive();

  if (tweakUrl == null) {
    return null;
  }

  return (
    <Button
      startIcon={<SlidersHorizontal />}
      variant="outlined"
      render={
        // biome-ignore lint/a11y/useAnchorContent: Content is injected by the component.
        <a href={tweakUrl} />
      }
    >
      Tweak it
    </Button>
  );
}
